<div class="container">
  <div class="logo">
    <img src="../../../assets/svg/logos/saude_conectada_logo.svg" alt="" />
  </div>
  <div class="form-wrapper">
    <form class="form">
      <div class="spacer" style="height: 10px"></div>

      <p>Que bom te ver por aqui!</p>

      <div class="spacer" style="height: 10px"></div>

      <p>
        Por favor, insira sua data de nascimento e número de celular para
        iniciar.
      </p>

      <div class="spacer" style="height: 20px"></div>

      <mat-form-field appearance="outline" class="full-width nascimento">
        <mat-label>Data de nascimento</mat-label>
        <input
          matInput
          type="text"
          mask="00/00/0000"
          [(ngModel)]="nascimento"
          [dropSpecialCharacters]="false"
          name="nascimento"
          required
          #nascimentoRef="ngModel"
        />
        @if (nascimentoRef.invalid && nascimentoRef.touched) {
        <mat-error> Campo obrigatório </mat-error>
        }
      </mat-form-field>
      <div class="spacer" style="height: 10px"></div>

      <div class="telefone-input">
        <mat-form-field appearance="outline" class="full-width country">
          <mat-label>País</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="pais"
            name="pais"
            required
            readonly
            placeholder="Clique para selecionar"
            (mousedown)="onCountryClick($event)"
            #paisRef="ngModel"
          />

          @if (paisRef.invalid && paisRef.touched) {
            <mat-error> Campo obrigatório </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width phone">
          <mat-label>Telefone celular</mat-label>
          <input
            matInput
            type="text"
            [mask]="mascaraTelefone()"
            [(ngModel)]="telefoneCelular"
            [dropSpecialCharacters]="false"
            name="telefoneCelular"
            required
            #telefoneCelularRef="ngModel"
          />

          @if(telefoneCelularRef.invalid && telefoneCelularRef.touched){
          <mat-error> Campo obrigatório </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="privacy">
        <mat-checkbox
          class="custom-checkbox"
          (change)="togglePrivacyPolicy()"
        ></mat-checkbox>
        <p>
          Eu li concordo com o termo de
          <span class="privacy-link" (click)="abrirPoliticaDePrivacidade()"
            >Política de Privacidade</span
          >
          do Saúde Conectada.
        </p>
      </div>

      @if(!!errorMessage()){
      <mat-error> {{ errorMessage() }} </mat-error>
      }

      <div class="spacer" style="height: 10px"></div>
      <button
        matButton="filled"
        class="full-width"
        type="button"
        (click)="$event.preventDefault(); onLogin()"
      >
        Iniciar
      </button>
    </form>
  </div>

  <div class="footer">
    <img src="../../../assets/svg/logos/sesi_logo.svg" alt="" />
  </div>
</div>
